import { db } from "./firebase"

const connectedRef = db.ref(".info/connected")

export default {
  onConnectionChanged(callback, errorCallback) {
    connectedRef.on(
      "value",
      snap => {
        const isConnected = snap.val() === true
        callback(isConnected)
      },
      errorCallback
    )
  }
}
